'use client'

import { useState, useCallback, useEffect } from 'react'

// Small grey placeholder when Gumlet placeholder fails (matches old server fallback intent)
const FALLBACK_PLACEHOLDER =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'%3E%3Crect fill='%23d1d5db' width='1' height='1'/%3E%3C/svg%3E"

export const PlaceholderImage = ({
  src,
  alt,
  className,
}: PlaceholderImageProps) => {
  const [imgSrc, setImgSrc] = useState(src)

  useEffect(() => {
    queueMicrotask(() => {
      setImgSrc(src)
    })
  }, [src])

  const handleError = useCallback(() => {
    setImgSrc(FALLBACK_PLACEHOLDER)
  }, [])

  return (
    <img
      src={imgSrc}
      alt={alt}
      className={className}
      onError={handleError}
    />
  )
}

interface PlaceholderImageProps {
  src: string
  alt?: string
  className?: string
}
